import { render, staticRenderFns } from "./modalChangePassword.vue?vue&type=template&id=13357598&"
import script from "./modalChangePassword.vue?vue&type=script&lang=js&"
export * from "./modalChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports